import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SubmenuWarehouse from '../submenu/SubmenuWarehouse'
import WorkLinePlace from '../../workLinePlace/WorkLinePlace'

const WorkPlaceLineWarehouse = () => {
  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuWarehouse />
		</MyBlock>
        <MyBlockHeader
            header={'Фіксація за робочим місцем на складі'}
            // isBack={true}
            // options={
            //     <FactoryOneOptions 
            //         factoryId={id}
            //     />
            // }
        />
        {/* <MyBlock>
            <BoxOneOptions 
                boxId={boxId}
            />
        </MyBlock> */}
		<MyBlock>
            <WorkLinePlace 
                department='warehouse'
            />
		</MyBlock>
    </LayoutMain>
  )
}

export default WorkPlaceLineWarehouse